import React from "react";

const HistoryIcon = () => {
  return (
    <>
      <svg width="18.076" height="17.893" viewBox="0 0 18.076 17.893">
        <g
          id="Group_283"
          data-name="Group 283"
          transform="translate(-2.548 -2.624)"
        >
          <path
            id="Path_2530"
            data-name="Path 2530"
            d="M9.664,19.918A8.56,8.56,0,0,1,7.3,19M13.468,3.223a8.563,8.563,0,0,1,0,16.7m-8.96-3.5a8.56,8.56,0,0,1-1.167-2.465m-.217-3.805A8.536,8.536,0,0,1,3.98,7.6l.161-.29m2.581-2.8a8.56,8.56,0,0,1,2.942-1.29"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2531"
            data-name="Path 2531"
            d="M12,8v4l3,3"
            transform="translate(-0.522 -0.389)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </svg>
    </>
  );
};

export default HistoryIcon;
